var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = '$';
Shopify.formatMoney = function (cents, format) {
	if (typeof cents === 'string') { cents = cents.replace('.', ''); }
	let value = '';
	const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
	const formatString = (format || this.money_format);

	function defaultOption(opt, def) {
		return (typeof opt === 'undefined' ? def : opt);
	}

	function formatWithDelimiters(number, precision, thousands, decimal) {
		precision = defaultOption(precision, 2);
		thousands = defaultOption(thousands, ',');
		decimal = defaultOption(decimal, '.');

		if (isNaN(number) || number == null) { return 0; }

		number = (number / 100.0).toFixed(precision);

		const parts = number.split('.');
		const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
		const cents = parts[1] ? (decimal + parts[1]) : '';

		return (dollars + cents).replaceAll('&nbsp;', '\xa0');
	}

	switch (formatString.match(placeholderRegex)[1]) {
		case 'amount':
			value = formatWithDelimiters(cents, 2);
			break;
		case 'amount_no_decimals':
			value = formatWithDelimiters(cents, 0);
			break;
		case 'amount_with_comma_separator':
			value = formatWithDelimiters(cents, 2, '.', ',');
			break;
		case 'amount_no_decimals_with_comma_separator':
			value = formatWithDelimiters(cents, 0, '.', ',');
			break;
	}

	return formatString.replace(placeholderRegex, value);
};

Shopify.formatDate = function (dateStr, byLocale = true, isoDateFormat = false) {
	if (byLocale) {
		const date = new Date(dateStr);
		const options = {day: 'numeric', month: 'numeric', year: 'numeric'};
		return new Intl.DateTimeFormat(`${Shopify.locale}-${Shopify.country}`, options).format(date);
	}

	const date = new Date(dateStr);
	const year = date.getFullYear();
	const month = (date.getMonth() + 1).toString().padStart(2, '0');
	const day = date.getDate().toString().padStart(2, '0');
	if (isoDateFormat) {
		return `${year}-${month}-${day}`;
	}
	return `${day}.&nbsp;${month}.&nbsp;${year}`;
};